export default {
  props: {},
  data() {
    return {
      pArr: [{
        icon: 'icon-lefttop',
        type: 'left-top'
      }, {
        icon: 'icon-leftbottom',
        type: 'left-bottom'
      }, {
        icon: 'icon-righttop',
        type: 'right-top'
      }, {
        icon: 'icon-rightbottom',
        type: 'right-bottom'
      }],
      pIndex: 0,
      ptype: 'left-top',
      pos: {
        left: '',
        right: '',
        bottom: '',
        top: ''
      },
      ptypeArr: [{
        name: '左',
        type: 'left'
      }, {
        name: '右',
        type: 'right'
      }, {
        name: '上',
        type: 'top'
      }, {
        name: '下',
        type: 'bottom'
      }]
    };
  },
  methods: {
    changeHandle(item, index) {
      this.pIndex = index;
      this.ptype = item.type;
    }
  }
};